export enum ListErrorType {
  FailedToLoadList = 1,
  FailedToRefreshList = 2,
}
